import { render, staticRenderFns } from "./BillboardPresetEdit.vue?vue&type=template&id=2f08d1a7&"
import script from "./BillboardPresetEdit.vue?vue&type=script&lang=ts&"
export * from "./BillboardPresetEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports